import { type FC } from "react"

import { usePlatform } from "~/contexts/PlatformContext"

const CookiePolicy: FC = () => {
	const platform = usePlatform().platform

	return (
		<>
			<p>Effective Date: 2025-02-14</p>

			<h2>Introduction</h2>
			<p>
				Welcome to {platform.name} ("Company," "we," "our," or "us"). This Cookie Policy explains how we use
				cookies and similar technologies on our website{" "}
				<a target="_blank" rel="noopener noreferrer" href={`https://${platform.domain.platform}`}>
					{platform.domain.platform}
				</a>{" "}
				("Website"). By using our Website, you agree to our use of cookies in accordance with this policy.
			</p>

			<h2>What Are Cookies?</h2>
			<p>
				Cookies are small text files stored on your device (computer, tablet, or mobile phone) when you visit a
				website. They help us enhance user experience, improve website functionality, and analyze website
				traffic.
			</p>

			<h2>Types of Cookies We Use</h2>
			<p>We use the following types of cookies:</p>
			<ul>
				<li>
					<strong>Essential Cookies</strong>: These are necessary for the Website to function properly. They
					enable core functionalities such as security, network management, and accessibility.
				</li>
				<li>
					<strong>Performance and Analytics Cookies</strong>: These cookies help us understand how visitors
					interact with our Website by collecting and reporting information anonymously.
				</li>
			</ul>

			<h2>Specific Cookies We Use</h2>
			<p>Below is a list of cookies we use on our Website:</p>
			<table>
				<thead>
					<tr>
						<th>Cookie Name</th>
						<th>Type</th>
						<th>Purpose</th>
						<th>Expiration</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>platform-cookie-option</td>
						<td>Essential</td>
						<td>Stores user cookie consent</td>
						<td>1 year</td>
					</tr>
					<tr>
						<td>session</td>
						<td>Essential</td>
						<td>Maintains user session</td>
						<td>6 months</td>
					</tr>
					<tr>
						<td>mtm_cookie_consent</td>
						<td>Essential</td>
						<td>Stores user consent for marketing cookies</td>
						<td>30 years</td>
					</tr>
					<tr>
						<td>_pk_id</td>
						<td>Analytics</td>
						<td>Stores a unique visitor ID</td>
						<td>13 months</td>
					</tr>
					<tr>
						<td>_pk_ses</td>
						<td>Analytics</td>
						<td>Session cookie temporarily stores data for the visit</td>
						<td>30 minutes</td>
					</tr>
					<tr>
						<td>_pk_ref</td>
						<td>Analytics</td>
						<td>Stores attribution information (the referrer that brought the visitor to the website)</td>
						<td>6 months</td>
					</tr>
					<tr>
						<td>_pk_testcookie</td>
						<td>Analytics</td>
						<td>
							Temporary cookie to check if a visitor's browser supports cookies (set in Internet Explorer
							only)
						</td>
						<td>Temporary cookie that expires almost immediately after being set.</td>
					</tr>
				</tbody>
			</table>

			<h2>How We Use Cookies</h2>
			<p>We use cookies to:</p>
			<ul>
				<li>Ensure the proper functioning of our Website.</li>
				<li>Remember your preferences and settings.</li>
				<li>Analyze Website traffic and improve performance.</li>
				<li>Deliver targeted advertisements and measure their effectiveness.</li>
			</ul>

			<h2>Managing Cookies</h2>
			<p>
				You can manage or delete cookies at any time by adjusting your browser settings. Most browsers allow you
				to:
			</p>
			<ul>
				<li>Block or delete cookies.</li>
				<li>Set preferences for how cookies are handled.</li>
				<li>Receive notifications when a website attempts to place a cookie on your device.</li>
			</ul>

			<h2>Third-Party Cookies</h2>
			<p>
				We may use third-party services (e.g., Google Analytics, advertising partners) that place cookies on
				your device. These cookies are governed by the respective third parties' privacy policies. We recommend
				reviewing their policies for more information.
			</p>

			<h2>Changes to This Cookie Policy</h2>
			<p>
				We may update this Cookie Policy from time to time. Any changes will be posted on this page with an
				updated effective date. We encourage you to review this policy periodically.
			</p>

			<h2>Contact Us</h2>
			<p>If you have any questions about this Cookie Policy, please contact us at:</p>
			<p>{platform.name}</p>
			<p>{platform.contactEmail}</p>
		</>
	)
}

export default CookiePolicy
